import { useState, type FormEvent } from 'react'

interface LoginScreenProps {
  error: string | null
  onSubmit: (email: string, password: string) => Promise<void>
}

export function LoginScreen({ error, onSubmit }: LoginScreenProps) {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [busy, setBusy] = useState(false)

  async function submit(event: FormEvent) {
    event.preventDefault()
    setBusy(true)
    try {
      await onSubmit(email.trim(), password)
    } catch {
      // The error is surfaced through the session state, not thrown at the user.
    } finally {
      setBusy(false)
    }
  }

  return (
    <main className="login">
      <div className="login__box">
        <div className="login__brand">
          <span className="rail__mark" aria-hidden="true">
            ◈
          </span>
          Базы знаний
        </div>
        <p className="muted" style={{ margin: '0 0 18px', fontSize: 12.5, lineHeight: 1.55 }}>
          Вход по аккаунту Protocore.
        </p>
        <form onSubmit={submit}>
          <div className="field">
            <label htmlFor="login-email">Email</label>
            <input
              id="login-email"
              className="input"
              type="email"
              autoComplete="username"
              required
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
          </div>
          <div className="field">
            <label htmlFor="login-password">Пароль</label>
            <input
              id="login-password"
              className="input"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </div>
          <button type="submit" className="btn btn--primary btn--block" disabled={busy}>
            {busy ? 'Входим…' : 'Войти'}
          </button>
          {error ? (
            <p className="error-text" style={{ margin: 0, fontSize: 12.5 }}>
              {error}
            </p>
          ) : null}
        </form>
      </div>
    </main>
  )
}
